module.exports = __webpack_public_path__ + "static/Aeonik-Regular-52bf9dc2acdd94346ef2a7db00e3004c.ttf";